import { render, staticRenderFns } from "./AreaNewsPage.vue?vue&type=template&id=28b7157f&scoped=true"
import script from "./AreaNewsPage.vue?vue&type=script&lang=js"
export * from "./AreaNewsPage.vue?vue&type=script&lang=js"
import style0 from "./AreaNewsPage.vue?vue&type=style&index=0&id=28b7157f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7157f",
  null
  
)

export default component.exports